import {
  DialogRoot,
  DialogPortal,
  DialogBackdrop,
  DialogPopup,
  DialogHeader,
  DialogTitle,
  DialogContent,
  DialogCloseButton,
} from '../ui/dialog';
import { TradeForm, type TradeFormData } from '../forms/trade-form';
import type { PortfolioInput } from '../../lib/investments';
import type { InvestmentAsset, Trade } from '../../types';

export interface TradeDialogProps {
  open: boolean;
  editing: Trade | null;
  assets: InvestmentAsset[];
  portfolio: PortfolioInput;
  defaultAssetId?: string;
  onSubmit: (data: TradeFormData) => void;
  onClose: () => void;
}

export function TradeDialog({
  open,
  editing,
  assets,
  portfolio,
  defaultAssetId,
  onSubmit,
  onClose,
}: TradeDialogProps) {
  return (
    <DialogRoot
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
    >
      <DialogPortal>
        <DialogBackdrop className="z-40" />
        <DialogPopup className="z-41 max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{editing ? 'Editar operação' : 'Nova operação'}</DialogTitle>
            <DialogCloseButton />
          </DialogHeader>
          <DialogContent>
            <TradeForm
              onSubmit={onSubmit}
              onClose={onClose}
              initialData={editing}
              assets={assets}
              portfolio={portfolio}
              defaultAssetId={defaultAssetId}
            />
          </DialogContent>
        </DialogPopup>
      </DialogPortal>
    </DialogRoot>
  );
}
